const noShowKeys = {
  all: ['no-shows'],
  practice: (hospital_name: string) => ['no-shows', hospital_name, 'practice']
};

export default noShowKeys;
